import { CloseIcon, ChevronRightIcon, HouseIcon } from "./icons";

export default function BottomSheet({ open, title, sub, items, onClose }) {
  if (!open) return null;
  return (
    <div className="overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="sheet-box">
        <div className="sheet-box__head">
          <span className="sheet-box__icon">
            <HouseIcon />
          </span>
          <span className="sheet-box__titles">
            <span className="sheet-box__title">{title}</span>
            <span className="sheet-box__sub">{sub}</span>
          </span>
          <button type="button" className="sheet-box__close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className="sheet-box__list">
          <div className="sheet-box__list-inner">
            {items.map((item) => (
              <button
                key={item.key}
                type="button"
                className={"sheet-item" + (item.full ? " sheet-item--full" : "")}
                onClick={item.onClick}
                disabled={item.full}
              >
                {item.logoUrl !== undefined && (
                  <span
                    className="sheet-item__logo"
                    style={item.logoUrl ? { backgroundImage: `url("${item.logoUrl}")` } : { display: "grid", placeItems: "center", font: "600 11px/14px Poppins", color: "var(--ink-600)" }}
                  >
                    {!item.logoUrl && item.label}
                  </span>
                )}
                <span style={{ flex: 1, textAlign: "left", minWidth: 0 }}>
                  <span className="sheet-item__label" style={{ color: item.full ? "var(--ink-400)" : "var(--ink-900)" }}>
                    {item.label}
                  </span>
                  {item.meta && <span className="sheet-item__meta">{item.meta}</span>}
                </span>
                {item.tag && (
                  <span className="sheet-item__tag" style={item.tagStyle}>
                    {item.tag}
                  </span>
                )}
                <span className="sheet-item__chev" style={{ color: item.full ? "#ccc" : "var(--brand-cyan)" }}>
                  <ChevronRightIcon />
                </span>
              </button>
            ))}
          </div>
        </div>
        <div className="sheet-box__foot">
          <button type="button" className="btn-cancel-full" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
